import Hero from "components/shared/hero/Hero";
import Title from "components/shared/hero/title/Title";
import Description from "components/shared/hero/description/Description";
import Container from "components/shared/container/Container";
import StoreLogos from "./storeLogos/StoreLogos";
import ExtraInfo from "./extraInfo/ExtraInfo";
import DoubleCard from "./doubleCard/DoubleCard";
import BalanceCheckForm from "./balanceCheckForm/BalanceCheckForm";

import {
    BalanceCheckStyled,
    Image,
    Content,
    BalanceCheckCard
} from "./BalanceCheck.styled";

function BalanceCheck() {
    const breadcrumbItems = [
        {
            title: "Saldocheck",
            url: "/saldocheck"
        }
    ];

    return (
        <BalanceCheckStyled>
            <Hero
                breadcrumbs={breadcrumbItems}
                contentWidth="half"
                background={<Image />}
            >
                <Content>
                    <Title>Saldocheck</Title>
                    <Description>
                        Gefeliciteerd met je Lees! Cadeaukaart. Je kunt hier de
                        waarde en de geldigheid van de cadeaukaart controleren.
                        Hierna kan de cadeaukaart online of in de winkel
                        ingewisseld worden bij de onderstaande acceptanten:
                    </Description>
                    <StoreLogos />
                </Content>
            </Hero>
            <Container>
                <BalanceCheckCard>
                    <BalanceCheckForm />
                    <ExtraInfo />
                </BalanceCheckCard>
                <DoubleCard />
            </Container>
        </BalanceCheckStyled>
    );
}

export default BalanceCheck;
